import React, { useState, Fragment } from "react";
import { Button } from "antd";
import { useMutation } from "@apollo/client";
import { UPDATE_TUTORIAL_NAME, PUBLISH_TUTORIAL } from "./queries";
import EditableText from "../../../presentational/EditableText";
import ConfirmDialog from "../../../presentational/ConfirmDialog";
import TutorialPublishResultModal from "../../../presentational/TutorialPublishResultModal";
import {
  EditIcon,
  TutorialNameEditable,
  TutorialNameInput,
  TutorialLabel,
  TutorialHeadCardContainer,
  TutorialHeadCardContainerTop,
  TutorialHeadCardContainerMiddle,
  TutorialHeadCardContainerBottom,
  TutorialStatusPill,
  DoneIcon,
  CharCount,
} from "./styled";
import CollapseArrowIcon from "../../../presentational/CollapseArrowIcon";

const getLatestStatus = (studentSpecificObjects) =>
  studentSpecificObjects && studentSpecificObjects.length > 0 ? studentSpecificObjects[0].status : "";

const TutorialCardHeader = ({
  title,
  learningUnitsCount,
  status,
  tutorialId,
  isActive,
  isReadOnly,
  subjectTutorialId,
  hasPublishableLU,
  onPublishComplete,
}) => {
  const [editTitle, setEditTitle] = useState(false);
  const [isTitleEditing, setIsTitleEditing] = useState(false);
  const [tutorialTitleInput, setTutorialTitleInput] = useState(title);
  const [tutorialTitle, setTutorialTitle] = useState(title);
  const [resultsModal, setResultsModal] = useState({ visible: false, results: [] });
  const maxLength = 100;

  const [updateSubjectTutorialDisplayName, { loading: loadingRemoveLU }] = useMutation(UPDATE_TUTORIAL_NAME, {
    onCompleted: (data) => {
      setTutorialTitle(data.updateSubjectTutorialDisplayName.displayName);
    },
    onError: (data) => {
      // TODO: show error toast?
      // console.warn("ERROR PLEASE REFRESH PAGE");
    },
  });

  // NOTE: refetchQueries is intentionally not used — apollo-client 2.x does not refetch the
  // SubjectBuilder manifest query (it runs with fetchPolicy: "no-cache"). Instead we update local
  // state via onPublishComplete so the PUBLISHED pills refresh immediately.
  const [publishTutorial, { loading: publishing }] = useMutation(PUBLISH_TUTORIAL, {
    onCompleted: (data) => {
      const results = data.publishTutorial || [];
      setResultsModal({ visible: true, results });
      if (onPublishComplete) onPublishComplete(results);
    },
    onError: (data) => {
      // TODO: show error toast?
    },
  });
  const handleInputChange = (value) => {
    if (value.length <= maxLength) {
      setTutorialTitleInput(value);
    }
  };

  const handleInputFocus = (editing) => {
    setIsTitleEditing(editing);
  };

  return (
    <Fragment>
    <TutorialHeadCardContainer
      onClick={(e) => {
        if (editTitle) e.stopPropagation();
      }}
    >
      <TutorialHeadCardContainerTop>
        <TutorialLabel>{!isReadOnly ? "TUTORIAL" : "TUTORIAL (READ ONLY)"}</TutorialLabel>
        <div>{<CollapseArrowIcon direction={isActive ? "up" : "down"} />}</div>
      </TutorialHeadCardContainerTop>
      <TutorialHeadCardContainerMiddle>
        <EditableText
          isEditable={!isReadOnly}
          value={tutorialTitleInput}
          onChange={handleInputChange}
          onEditStateChange={handleInputFocus}
          onBlur={() => {
            if (tutorialTitleInput !== tutorialTitle) {
              updateSubjectTutorialDisplayName({
                variables: {
                  tutorialId,
                  subjectTutorialId,
                  name: tutorialTitleInput,
                },
              });
            }
          }}
        />
        {isTitleEditing && (
          <CharCount>
            {tutorialTitleInput.length}/{maxLength}
          </CharCount>
        )}
      </TutorialHeadCardContainerMiddle>
      <TutorialHeadCardContainerBottom>
        <TutorialLabel>
          {learningUnitsCount} {learningUnitsCount === 1 ? "Learning Unit" : "Learning Units"}
        </TutorialLabel>
        {/* Wrapper span stops the click from toggling the Collapse panel header without
            interfering with Popconfirm's own click handler on the Button (antd v3-safe). */}
        <span onClick={(e) => e.stopPropagation()}>
          <ConfirmDialog
            placement="bottom"
            title="Publish all ready learning units in this tutorial?"
            onConfirm={() => publishTutorial({ variables: { tutorialId } })}
            disabled={isReadOnly || publishing || !hasPublishableLU}
          >
            <Button loading={publishing} disabled={isReadOnly || !hasPublishableLU} style={{color: "rgba(0, 0, 0, 0.65)" }}>
              PUBLISH TUTORIAL
            </Button>
          </ConfirmDialog>
        </span>
      </TutorialHeadCardContainerBottom>
    </TutorialHeadCardContainer>
      <TutorialPublishResultModal
        visible={resultsModal.visible}
        results={resultsModal.results}
        onClose={() => setResultsModal({ visible: false, results: [] })}
      />
    </Fragment>
  );
};

export default TutorialCardHeader;
